import {
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
  OnInit,
  Optional,
  Self,
  ChangeDetectionStrategy
} from '@angular/core';
import { AbstractValueAccessor } from 'ZalamoLibrary/src/lib/core/form/FormControl';
import { UntypedFormControl, NgControl } from '@angular/forms';
import { CustomConfigOption } from 'ZalamoLibrary/src/lib/ui/products/types';
import { tap } from 'rxjs/operators';

interface SingleOption {
  label: Array<{ language: string; text: string }>;
  description: Array<{ language: string; text: string }>;
  picked: boolean;
  paramId: string;
  icon: string;
}

@Component({
    selector: 'lib-list-picker',
    templateUrl: './list-picker.component.html',
    styleUrls: ['./list-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ListPickerComponent
  extends AbstractValueAccessor
  implements OnInit
{
  visibleOptions: Array<SingleOption> = [];
  mode: 'select' | 'buttons' = 'select';
  control = new UntypedFormControl();
  @HostBinding('class.iconMode') iconMode = false;
  @Input() limitOptions = false;
  @Input() availableOptions = [];

  @Input() set options(options: Array<CustomConfigOption>) {
    const limitationsInAttribute = !!options.find((o) =>
      o.relations?.find(
        (relation) =>
          this.availableOptions.includes(relation.id) ||
          this.availableOptions.includes(relation.value)
      )
    );

    options = options.filter(({ active, relations, label }) => {
      const hasMatchingRelation = !!relations?.find(
        (relation) =>
          this.availableOptions.includes(relation.id) ||
          this.availableOptions.includes(relation.value)
      );
      console.log(label);
      console.log({ hasMatchingRelation });
      return (
        active && (!this.limitOptions || !relations || hasMatchingRelation)
      );
    });
    this.mode = options.length > 8 ? 'select' : 'buttons';
    this.visibleOptions = options.map((options) => ({
      label: options.label,
      description: options.description,
      icon: options.icon,
      picked:
        this.visibleOptions.find(({ picked }) => picked)?.paramId ===
        options.configId,
      paramId: options.configId,
    }));
    this.iconMode = this.visibleOptions.filter(({ icon }) => icon).length > 0;
  }

  constructor(
    @Self() @Optional() public ngControl: NgControl,
    private cd: ChangeDetectorRef
  ) {
    super();
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit(): void {
    this.subscribeWhileAlive(
      this.valueSubject.pipe(
        tap((newValue) => {
          console.log(newValue);

          this.visibleOptions.forEach(({ paramId }, index, all) => {
            all[index].picked = paramId === newValue;
          });
          console.log(this.visibleOptions);

          this.cd.detectChanges();
        })
      ),
      this.control.valueChanges.pipe(
        tap((newValue) => {
          this.writeValue(newValue);
        })
      )
    );
  }

  resetOptions() {
    this.visibleOptions.forEach(
      (value, index1, array) => (array[index1].picked = false)
    );
  }

  pick(index) {
    console.log('pickewd');
    this.resetOptions();
    this.visibleOptions[index].picked = true;
    console.log(this.visibleOptions);
    this.writeValue(this.visibleOptions[index].paramId);
    this.cd.detectChanges();
  }

  trackOption(i, option: SingleOption) {
    return option.paramId;
  }
}
